import { render, staticRenderFns } from "./Viewbusinesscategory.vue?vue&type=template&id=1c56a0ef&"
import script from "./Viewbusinesscategory.vue?vue&type=script&lang=js&"
export * from "./Viewbusinesscategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports